"use strict";

function PaymentService(
	serviceWrapper,
	portalServiceWrapper,
	$state,
	storage,
	userInputRepository,
	quoteModelFactory,
	util,
	quoteOptions,
	paymentLoggerService
) {
	var EMBARGO_STATE = "embargo";

	function getItemById (key, configs) {
		for (var i = 0; i < configs.length; i++) {
			if (configs[i].id === key) {
				return configs[i].title;
			}
		}
		return '';
	};

	//global variable from page layout
	// return data structure {clientId: '', clientSecret: '', merchantIdentifier: '', mulesoftFlexiMicroformApiUrl: ''}
	function getPaybillConfig() {
		//return endpointUrls.payments.ausPortalUISettings;
		return appConfigs.payments.ausPortalUISettings;
	}

	/* call mulesoft to prepare tokenization of cc number */
	function initialCreditcardPayment(initialCreditcardPaymentUrl, host, guid, merchantId, clientId, clientSecret, successCallback, errorCallback) {
		serviceWrapper.initialCreditcardPayment(initialCreditcardPaymentUrl, host, guid, merchantId, clientId, clientSecret)
		.then(function(response) {
			var jwk = response.data.jwk;
			successCallback(jwk);
		})
		.catch(function(error) {
			errorCallback(error);
		});
	}

	function generateUniqueId() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {  
			var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);  
			return v.toString(16);  
		 });
	}
	function getKeyData(jwk, cardNumberFieldId, cardNumberLabelId, placeholderText) {
        return {
            keyId: jwk.kid,
            keystore: jwk,
            container: cardNumberFieldId,
            label: cardNumberLabelId,
            placeholder: placeholderText,
            styles: {
                'input': {
                    'font-family': 'Verdana',
                    'font-size': '15px',
                    'line-height': '1.5',
					'color': '#343e44'
                },
                ':focus': {'color': '#343e44'},
                ':disabled': {'cursor': 'not-allowed'},
                'valid': {'color': '#343e44'},
                'invalid': {'color': '#343e44'},
            },
            encryptionType: 'rsaoaep'
        };
    }
    function flexiFormFunction (microformInstance, payButton, cardExpirationMonth, cardExpirationYear, flexResponse, submitForm) {

        // intercept the form submission and make a tokenize request instead
        payButton.addEventListener('click', function () {

            // Send in optional parameters from other parts of your payment form
            var options = {
                cardExpirationMonth: cardExpirationMonth, //expMonth.value,
                cardExpirationYear: cardExpirationYear, //expYear.value
            };

            microformInstance.createToken(options, function (err, response) {
                if (err) {
                    console.log(err);
                    return;
                }

                // At this point the token may be added to the form
                // as hidden fields and the submission continued
                flexResponse.value = JSON.stringify(response);
                submitForm();
            });
        });
    }
	/**
	 * Pays by credit card
	 * The entire flow is as follows:
	 * 	1 - Create a payment with GuideWire
	 * 	2 - Generate Cybersource form data using response from GuideWire and credit card data entered by the user
	 * 	3 - Convert the form data into a form (in an iFrame on the Payments page)
	 * 	4 - The following happens in the iFrame
	 * 		4.1 - Submit the form (in the iFrame) to Cybersource using a form.submit()
	 * 		4.2 - Cybersource responds back with an HTML page that contains a form. This form auto-submits to GuideWire
	 * 		4.3 - Guidewire loads a callback page (Angular) in the iFrame. This page tells the parent (Payment) page that the payment was successful/unsuccessful
	 * 	5 - When the Payment page receives the payment complete from the iFrame, transition to the Confirmation page
	 *
	 * @param {Object} creditCard					Object with credit card data submitted by user
	 * @param {Function} successCallback			Success callback that accepts argument of type `Object` with form data to submit to Cybersource
	 * @param errorCallback							Error callback that accepts argument argument of type `ErrorResponse`
	 */
	function payByCreditCard(creditCard, successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());
		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-credit card",
					"generate cybersource form data",
					null
				);
				return _createCreditCardPayment();
			})
			.then(function(_createCreditCardPaymentResponse) {
				var formData = _generateCybersourceFormData(
					_createCreditCardPaymentResponse,
					creditCard
				);
				paymentLoggerService.trackQuoteStatus(
					"generating Cybersource form data",
					"submit payment to Cybersource",
					null
				);
				successCallback(formData);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-credit card",
					null,
					response
				);
				if (response.declineType === "embargo")
					$state.go(EMBARGO_STATE, response);
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-credit card');
					}

					errorCallback(response);							
				}
			});
	}

	function unAuthCreditCardPayment(
		creditCard,
		successCallback,
		errorCallback
	) {
		var paymentData = {
			referenceID: creditCard.referenceNumber,
			paymentType: creditCard.paymentType,
			redirectUrl: $state.href(
				"cybersourceCallback",
				{},
				{
					absolute: true
				}
			),
			payWithToken: true,
			payment_token: creditCard.cardToken
		};

		// call GW to get to create payload
		serviceWrapper
			.createCreditcardPayment(paymentData)
			.then(function(_createCreditCardPaymentResponse) {
				var formData = _generateCybersourceFormData(
					_createCreditCardPaymentResponse,
					creditCard
				);
				paymentLoggerService.trackQuoteStatus(
					"generating Cybersource form data",
					"submit payment to Cybersource",
					null
				);
				successCallback(formData);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-credit card",
					null,
					response
				);
				
				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-credit card');
				}

				errorCallback(response);
			});
	}

	function unAuthPaypalPayment(paymentInfo, successCallback, errorCallback) {
		var paymentData = {
			referenceID: paymentInfo.referenceNumber,
			paymentType: paymentInfo.paymentType,
			redirectUrl: $state.href(
				"paypalCallback",
				{},
				{
					absolute: true
				}
			)
		};

		serviceWrapper
			.createPaypalPayment(paymentData)
			.then(function(_createPaypalPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"generating Paypal payment response",
					"submit payment to Paypal",
					null
				);
				successCallback(_createPaypalPaymentResponse.data.redirectURL);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-paypal",
					null,
					response
				);

				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-paypal');
				}

				errorCallback(response);
			});
	}

	/**
	 * Pays by PayPal
	 * The flow is as follows:
	 * 	1 - Create a payment with GuideWire
	 * 	2 - GuideWire responds with a PayPal redirect URL
	 * 	3 - The browser is redirected to PayPal (using the redirect URL returned from the GuideWire service)
	 * 	4 - User completes payment in PayPal and is redirected back to a PayPal Payment Success page (Angular page)
	 * 	5 - If success parameters are passed to the PayPal Payment Success Page, send data to GuideWire PayPal Success service
	 * 	6 - Transition to Confirmation Page
	 *
	 * @param {Function} successCallback			Success callback that accepts argument `redirectUrl` of type `String`
	 * @param {Function} errorCallback				Error callback that accepts argument argument of type `ErrorResponse`
	 */
	function payByPaypal(successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());

		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-paypal",
					"generate Paypal payment response",
					null
				);
				return _createPaypalPayment();
			})
			.then(function(_createPaypalPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"generating Paypal payment response",
					"submit payment to Paypal",
					null
				);
				successCallback(_createPaypalPaymentResponse.data.redirectURL);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-paypal",
					null,
					response
				);
				if (response.declineType === "embargo") {
					$state.go(EMBARGO_STATE, response);
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-paypal. Declined. Type: embargo.');
					}
				}					
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-paypal');
					}
					errorCallback(response);
				}
			});
	}

	function unAuthDirectDebitPayment(
		bankAccount,
		successCallback,
		errorCallback
	) {
		bankAccount.bsb = convertBsbNumberToGuidewireFormat(bankAccount.bsb);

		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				amount: bankAccount.amountPay,
				referenceID: bankAccount.referenceNumber,
				paymentType: bankAccount.paymentType,
				bsbNumber: bankAccount.bsb,
				bankAccountNumber: bankAccount.accountNumber,
				accountHolderName: bankAccount.accountName
			};

		serviceWrapper
			.createDirectDebitPayment(paymentData)
			.then(function(_createDirectDebitPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"create direct debit payment response",
					"create direct debit payment",
					null
				);
				successCallback(_createDirectDebitPaymentResponse.data);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"pay bills error-direct debit",
					null,
					response
				);

				/* gtm track api error */
				if (response && response.status) {
					gtmService.trackApiError(response.status, 'pay bills error-direct debit');
				}

				if (errorCallback) {
					errorCallback(response);
				}
			});
	}

	/**
	 * Pays by Direct Debit
	 * A straight forward AJAX call to the directDebit service
	 * @param {Object} bankAccount					Bank account details entered by the user
	 * @param {Function} successCallback			Success callback that accept service response data as argument
	 * @param {Function} errorCallback				Error callback that accepts service error response as argument
	 */
	function payByDirectDebit(bankAccount, successCallback, errorCallback) {
		portalServiceWrapper.updateQuote(userInputRepository.get());
		var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

		portalServiceWrapper
			.saveQuote(paymentFrequency, {
				issueCheck: "true",
				quote: "true"
			})
			.then(function(response) {
				testEmbargoDecline(response);
				paymentLoggerService.trackQuoteStatus(
					"attempting to save quote-direct debit",
					"create direct debit payment",
					null
				);
				return _createDirectDebitPayment(bankAccount);
			})
			.then(function(_createDirectDebitPaymentResponse) {
				paymentLoggerService.trackQuoteStatus(
					"create direct debit payment response",
					"create direct debit payment",
					null
				);
				successCallback(_createDirectDebitPaymentResponse.data);
			})
			.catch(function(response) {
				paymentLoggerService.trackQuoteStatus(
					"saveQuote error-direct debit",
					null,
					response
				);
				if (response.declineType === "embargo") {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-direct debit. Declined. Type: embargo.');
					}

					$state.go(EMBARGO_STATE, response);
				}					
				else if (errorCallback) {
					/* gtm track api error */
					if (response && response.status) {
						gtmService.trackApiError(response.status, 'saveQuote error-direct debit.');
					}
					errorCallback(response);
				}
			});
	}

	function testEmbargoDecline(response) {
		// var data = response.data;

		// if (data.quoteResult && data.quoteResult.embargo == true) {
		// 	var declineParams = {
		// 		declineType: "embargo",
		// 		declineCodes: []
		// 	};

		// 	data.quoteResult.uwIssues.forEach(function(element) {
		// 		declineParams.declineCodes.push(element.typeCode);
		// 	}, this);

		// 	throw declineParams;
		// }
	}

	/**
	 * Creates a Direct Debit Payment in GuideWire
	 * Calls the GuideWire service to create a direct debit payment
	 * @param {Object} bankAccount
	 * @private
	 */
	function _createDirectDebitPayment(bankAccount) {
		bankAccount.bsb = convertBsbNumberToGuidewireFormat(bankAccount.bsb);

		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				bsbNumber: bankAccount.bsb,
				bankAccountNumber: bankAccount.accountNumber,
				accountHolderName: bankAccount.accountName
			};

		return serviceWrapper.createDirectDebitPayment(paymentData);
	}

	/**
	 * Converts BSB from a number to a string in this format "XXX-XXX".  As input is a number, leading 0's are removed by default
	 * so function pads with 0s if shorter than 6 digits
	 */
	function convertBsbNumberToGuidewireFormat(bsb) {
		var bsb = bsb + "";
		bsb = util.padNumber(bsb, 6, "0");
		return bsb.match(/.{3}/g).join("-");
	}

	/**
	 * Creates a Credit Card Payment in GuideWire
	 * Calls the GuideWire service to create a credit card payment. The data returned from this is then augmented with the credit card details, injected into a form and submitted to CyberSource
	 * @private
	 */
	function _createCreditCardPayment() {
		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				redirectUrl: $state.href(
					"cybersourceCallback",
					{},
					{
						absolute: true
					}
				)
			};
		return serviceWrapper.createCreditcardPayment(paymentData);
	}

	/**
	 * Creates a PayPal Payment in GuideWire
	 * Calls the GuideWire service to create a PayPal payment. The data returned is a redirectURL that is used to redirect the browser to PayPal for payment processing
	 * @private
	 */
	function _createPaypalPayment() {
		var quoteModel = quoteModelFactory.create(),
			paymentData = {
				referenceID: quoteModel.quoteId,
				paymentType: "QUOTE",
				redirectUrl: $state.href(
					"paypalCallback",
					{},
					{
						absolute: true
					}
				)
			};

		return serviceWrapper.createPaypalPayment(paymentData);
	}

	/**
	 * Sends successful PayPal payment data to GuideWire
	 * @param {String} payerId						PayerID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} sessionId					SessionID querystring parameter returned by PayPal in the PayPal Callback page
	 * @returns {Promise}							Promise to fulfil after data is sent to GuideWire service
	 */
	function sendPaypalPaymentToGW(payerId, sessionId) {
		var paymentData = {
			payerID: payerId,
			sessionID: sessionId
		};

		return serviceWrapper.sendPaypalPaymentToGw(paymentData);
	}

	/**
	 * Sends successful Unauthenticated PayPal payment data to GuideWire
	 * @param {String} payerId						PayerID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} sessionId					SessionID querystring parameter returned by PayPal in the PayPal Callback page
	 * @param {String} paymentId					PaymentID querystring parameter returned by PayPal in the PayPal Callback page
	 * @returns {Promise}							Promise to fulfil after data is sent to GuideWire service
	 */
	function unAuthSendPaypalPaymentToGW(payerId, sessionId, paymentId) {
		var paymentData = {
			payerID: payerId,
			sessionID: sessionId,
			paymentID: paymentId
		};

		return serviceWrapper.sendPaypalPaymentToGw(paymentData);
	}

	/**
	 * Generates data to submit to CyberSource
	 * This data will be used by a form in an iFrame to generate the form fields, which will then be posted to Cybersource
	 * @param {AJAXResponse} _createCreditCardPaymentResponse			Response from the GuideWire `_createCreditCardPayment` service call
	 * @param {Object} creditCard										Credit card data submitted by the user
	 * @private
	 */
	function _generateCybersourceFormData(
		_createCreditCardPaymentResponse,
		creditCard
	) {
		if (
			_createCreditCardPaymentResponse &&
			_createCreditCardPaymentResponse.data &&
			_createCreditCardPaymentResponse.data.formData
		) {
			if (creditCard.cardExpiryDate) {
				var date = moment(creditCard.cardExpiryDate, "MM/YY");
				var formattedDate = date.format("MM/YY");
				creditCard.cardExpiryDate = formattedDate.replace(
					/(\d+)\//,
					"$1-20"
				);
			}

			var formData = (creditCard.cardNumber) ?
			 angular.extend(
				{},
				_createCreditCardPaymentResponse.data.formData,
				{
					card_type: _getCyberSourceCardType(creditCard.type),
					card_number: creditCard.cardNumber,
					card_expiry_date: creditCard.cardExpiryDate,
					card_cvn: creditCard.cvc,
					merchant_secure_data1: creditCard.cardHolderName
				}
			 )
			 :
			 // payment_token is in _createCreditCardPaymentResponse.data.formData
			 angular.extend(
				{},
				_createCreditCardPaymentResponse.data.formData,
				{
					card_type: creditCard.type,
					card_expiry_date: creditCard.cardExpiryDate,
					card_cvn: creditCard.cvc,
					merchant_secure_data1: creditCard.cardHolderName,
				}
			 );

			return formData;
		}
	}

	/**
	 * Converts credit card type to Cybersource cardType ID
	 * @param cardType
	 * @returns {String}
	 * @private
	 */
	 function _getCyberSourceCardType(cardType) {
		var type = "";

		if (cardType) {
			type = cardType.toLowerCase();
		}

		switch (type) {
			case "visa":
				return "001";
			case "mastercard":
				return "002";
			case "american express":
				return "003";
		}
	}

	return {
		getPaybillConfig: getPaybillConfig,
		initialCreditcardPayment: initialCreditcardPayment,
		generateUniqueId: generateUniqueId,
		getKeyData: getKeyData,
		flexiFormFunction: flexiFormFunction,
		payByCreditCard: payByCreditCard,
		payByPaypal: payByPaypal,
		payByDirectDebit: payByDirectDebit,
		sendPaypalPaymentToGW: sendPaypalPaymentToGW,
		unAuthCreditCardPayment: unAuthCreditCardPayment,
		unAuthPaypalPayment: unAuthPaypalPayment,
		unAuthSendPaypalPaymentToGW: unAuthSendPaypalPaymentToGW,
		unAuthDirectDebitPayment: unAuthDirectDebitPayment
	};
}

PaymentService.bootstrap = function(
	$http,
	$state,
	storage,
	userInputRepository,
	portalServiceWrapper,
	quoteModelFactory,
	util,
	quoteOptions,
	paymentLoggerService
) {
	var userToken =
		"eyJhbGciOiJIUzI1NiJ9.eyJhdXRob3JpdGllcyI6WyJRVU9URToxMDAwMDQwODU2Il0sImlhdCI6MTQ2NDc0ODU1MiwiZXhwIjoxNDY0NzUyMTUyfQ.0GFJ-SxgqEq16Rr1PPC-lhAL0PxblesSRVa2bkRBWxM";

	var conf = {
		paybillConfig: function(host) {
			//for local
			var host1 = host;
			if (host1.indexOf('localhost') !== -1) {
				host1 = 'https://gsc-sys.au.qbe.com/';
			}

			return {
				method: "GET",
				url: host1 + '/api/spa/v3/configuration?id={89E52B78-FAE0-4B62-A2E1-CDD8F5F8713E}'
			}
		},
		initPaymentToken: function(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret) {
			return {
				method: "POST",
				url: initPaymentTokenUrl,
				headers: {
					"X-ClientId": clientId,
					"X-ClientSecret": clientSecret,
					"X-SourceSystem": "SIteCore",
					"X-TargetOrigin": host,
					"X-Mockable": "false"
				},
				data: {
					"guid": guid,
					"merchantIdentifier": merchantId
				}
			}
		},
		createCreditcardPayment: {
			method: "POST",
			url: endpointUrls.payments.createCreditcardPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		createPaypalPayment: {
			method: "POST",
			url: endpointUrls.payments.createPaypalPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		createDirectDebitPayment: {
			method: "POST",
			url: endpointUrls.payments.createDirectDebitPayment,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		},
		sendPaypalPaymentToGw: {
			method: "POST",
			url: endpointUrls.payments.sendPaypalPaymentToGw,
			headers: {
				"EY-Access-Key": "test123",
				"EY-Product-Type": "pc",
				"EY-USER-TOKEN": userToken,
				"X-Requested-By": "92tvt8iy2b"
			}
		}
	};

	var serviceWrapper = function() {
		return {
			paybillConfig: function(host) {
				var req = conf.paybillConfig(host);
				return $http(req);
			},
			initialCreditcardPayment: function(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret) {
				var req = conf.initPaymentToken(initPaymentTokenUrl, host, guid, merchantId, clientId, clientSecret);
				return $http(req);
			},
			createCreditcardPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}
				var req = conf.createCreditcardPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			createPaypalPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.createPaypalPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			createDirectDebitPayment: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.createDirectDebitPayment;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			},
			sendPaypalPaymentToGw: function(data) {
				if (storage.getItem("eyUserToken")) {
					userToken = storage.getItem("eyUserToken");
				}

				var req = conf.sendPaypalPaymentToGw;
				req.data = data;
				req.headers["EY-USER-TOKEN"] = userToken;

				return $http(req);
			}
		};
	};
	return new PaymentService(
		new serviceWrapper(),
		portalServiceWrapper,
		$state,
		storage,
		userInputRepository,
		quoteModelFactory,
		util,
		quoteOptions,
		paymentLoggerService
	);
};
